/* Naoko — Blog na stronie głównej: lekki slider (scroll-snap + strzałki). */
(function () {
  function initSection(root) {
    if (!root || root.__nbpInit) return;
    root.__nbpInit = true;

    var viewport = root.querySelector('.naoko-blog-posts__viewport');
    if (!viewport) return;
    var prev = root.querySelector('.naoko-blog-posts__arrow--prev');
    var next = root.querySelector('.naoko-blog-posts__arrow--next');

    function gapPx() {
      var cs = getComputedStyle(viewport);
      return parseFloat(cs.columnGap || cs.gap || '0') || 0;
    }

    function step() {
      var card = viewport.querySelector('.naoko-blog-posts__card');
      if (!card) return viewport.clientWidth;
      return card.getBoundingClientRect().width + gapPx();
    }

    function maxScroll() {
      return viewport.scrollWidth - viewport.clientWidth;
    }

    /* Wyśrodkuj strzałki w pionie do wysokości zdjęcia (nie całej karty). */
    function setArrowTop() {
      var media = root.querySelector('.naoko-blog-posts__media');
      if (media) {
        var h = media.getBoundingClientRect().height;
        if (h > 0) root.style.setProperty('--nbp-arrow-top', (h / 2) + 'px');
      }
    }

    function updateArrows() {
      var x = viewport.scrollLeft;
      var max = maxScroll();
      var scrollable = max > 2;
      if (prev) prev.classList.toggle('is-hidden', !scrollable || x <= 2);
      if (next) next.classList.toggle('is-hidden', !scrollable || x >= max - 2);
    }

    if (next) {
      next.addEventListener('click', function () {
        viewport.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }
    if (prev) {
      prev.addEventListener('click', function () {
        viewport.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }

    viewport.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateArrows);
    }, { passive: true });

    function recalc() {
      setArrowTop();
      updateArrows();
    }

    if ('ResizeObserver' in window) {
      new ResizeObserver(recalc).observe(viewport);
    } else {
      window.addEventListener('resize', recalc);
    }

    /* Wysokość media może się zmienić po doczytaniu zdjęć. */
    var imgs = root.querySelectorAll('.naoko-blog-posts__media img');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].complete) imgs[i].addEventListener('load', recalc, { once: true });
    }

    recalc();
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.naoko-blog-posts');
    for (var i = 0; i < nodes.length; i++) initSection(nodes[i]);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  }

  /* Theme editor: ponowna inicjalizacja po przeładowaniu sekcji. */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
